import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-o-three',
  templateUrl: './o-three.component.html',
  styleUrls: ['./o-three.component.scss']
})
export class OThreeComponent {
  constructor(public dialogRef: MatDialogRef<OThreeComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
